export class PropertyStatus {
  id!: number;
  name!: string;
  description!: string;
}
